import React, { Fragment } from "react";
import { Col, Row, Select } from "antd";
import { map } from "lodash-es";
import { useTranslation } from "react-i18next";
import cls from "classnames";

const ForecastDateFilter = ({
  year,
  month,
  day,
  shipType,
  dateRanges,
  layerGroup,
  selectYear,
  selectMonth,
  selectDay,
  selectShip,
  ranges,
}) => {
  const { t } = useTranslation();

  const yearSelectors = map(dateRanges, (v, k) => (
    <Col span={8} key={`year-selector-${k}`}>
      <div
        onClick={() => selectYear(Number(k))}
        className={cls("selector-btn", { active: year === Number(k) })}
      >
        {k}
      </div>
    </Col>
  ));
  const monthSelectors = map(dateRanges[year], (m, k) => {
    const label = k < 10 ? `0${k}` : `${k}`;
    return (
      <Col span={8} key={`month-selector-${k}`}>
        <div
          onClick={() => selectMonth(Number(k))}
          className={cls("selector-btn", { active: month === Number(k) })}
        >
          {label}
        </div>
      </Col>
    );
  });
  const daySelectors = map(dateRanges[year][month], (d) => {
    const label = d < 10 ? `0${d}` : `${d}`;
    return (
      <Col span={8} key={`day-selector-${d}`}>
        <div
          onClick={() => selectDay(d)}
          className={cls(
            "selector-btn",
            { active: day === d },
            { inactive: layerGroup === "route" && !ranges.includes(d) }
          )}
        >
          {label}
        </div>
      </Col>
    );
  });
  return (
    <div className="date-selector">
      {layerGroup === "route" && (
        <Fragment>
          <div className="subtitle">{t("timeline.ship")}</div>
          <Row gutter={16} style={{ marginTop: 15, marginBottom: 15 }}>
            <Col span={24} key={`co2-selector-4-5`}>
              <Select
                value={shipType}
                style={{ width: "100%" }}
                onChange={(value) => selectShip(value)}
              >
                <Select.Option value="PC1">{t("timeline.ship1")}</Select.Option>
                <Select.Option value="NO_ICE">
                  {" "}
                  {t("timeline.ship2")}
                </Select.Option>
              </Select>
            </Col>
          </Row>
        </Fragment>
      )}
      <div className="subtitle">{t("timeline.year")}</div>
      <Row gutter={16} style={{ marginTop: 15, marginBottom: 15 }}>
        {yearSelectors}
      </Row>
      <div className="subtitle">{t("timeline.month")}</div>
      <Row gutter={16} style={{ marginTop: 15 }}>
        {monthSelectors}
      </Row>
      <div className="subtitle">{t("timeline.day")}</div>
      <Row gutter={16} style={{ marginTop: 15 }}>
        {daySelectors}
      </Row>
    </div>
  );
};

export default ForecastDateFilter;
